module.exports = __webpack_public_path__ + "img/circle-preloader.647a7a72.svg";